// extracted by mini-css-extract-plugin
export default {"feacherDescription":"Feacher_feacherDescription__RitcN","arrow":"Feacher_arrow__BdgMi"};